export default __webpack_public_path__ + "static/media/page4Image1.45a48600.png";